import { render, staticRenderFns } from "./Receivables.vue?vue&type=template&id=4ca041f5&"
import script from "./Receivables.vue?vue&type=script&lang=js&"
export * from "./Receivables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports